
// Pure core for "Snap til andet punkt" - the interactive picking, preview and
// commit wiring lives in VectorEditingMenu.js (runSnapToOtherPoint()); this
// file only answers: may this picked vertex be used as the target, and (if so)
// what is the exact position the source vertex moves to. Both DOM/THREE-free
// and Level-1 testable.
//
// The operation is "move the SELECTED source vertex onto an EXISTING point's
// exact coordinate (full 3D, incl. Z)". This is one of the two operations
// (with "Forbind til andet endepunkt") where the user has EXPLICITLY asked for
// a precise XYZ coincidence, so the target's Z is adopted verbatim. It acts on
// the selected vertex ONLY - geometric coincidence at the source is not
// propagated to other features (stabilisation task §1.1 / §3). The numeric
// move itself is geometry/vectorEditing.js's movePoint(); the TARGET feature
// is never modified.
//
// Geometry vs. topology: establishing coordinate coincidence here does NOT
// create any connection/shared-node/DANVA relation - topology QA may detect it
// afterwards by its own rules.

// source / target: {featureId, vertexIndex}. The only rejection is "the exact
// same vertex" (source must not be snappable to itself); an absent target
// (click hit empty space / the point cloud) is not valid either.
export function isValidSnapTarget(source, target){
	if(!source || !target) return false;
	return !(source.featureId === target.featureId && source.vertexIndex === target.vertexIndex);
}

// "Snap til dette punkt" for en FLERVALGT mængde punkter (box-selection): alle valgte vertices flyttes til ét måls
// eksakte koordinat (fuld 3D, incl. Z). `entries`: [{featureId, vertexIndex, ...}] (ekstra felter bevares, fx visual);
// `target`: {featureId, vertexIndex}; `targetPosition`: {x,y,z} fra målvertex'ets rigtige geometri. Målvertex'et selv
// flyttes aldrig (hvis det er en del af valget, udelades det), og et vertex der er valgt to gange flyttes kun én gang.
// Returnerer [{...entry, position}] - kalderen udfører flytningerne pr. feature med movePoint()+applyFeatureGeometry().
export function planSnapSelectionToTarget(entries, target, targetPosition){
	if(!Array.isArray(entries) || !target || !targetPosition) return [];

	const seen = new Set();
	const moves = [];
	for(const entry of entries){
		if(!entry || entry.featureId == null) continue;
		if(!isValidSnapTarget({featureId: entry.featureId, vertexIndex: entry.vertexIndex}, target)) continue;
		const key = entry.featureId + ":" + entry.vertexIndex;
		if(seen.has(key)) continue;
		seen.add(key);
		moves.push({...entry, position: {x: targetPosition.x, y: targetPosition.y, z: targetPosition.z}});
	}
	return moves;
}

// targetPosition: {x,y,z} taken from the TARGET vertex's real geometry (never a
// fresh point-cloud pick at the click position). Returns the single
// {featureId, vertexIndex, position} the caller commits via
// movePoint()+applyFeatureGeometry().
export function snapMoveToTarget(source, targetPosition){
	return {
		featureId: source.featureId,
		vertexIndex: source.vertexIndex,
		position: {x: targetPosition.x, y: targetPosition.y, z: targetPosition.z},
	};
}
